package org.hs_soft.runmynesto.domain.model.home.media_center

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class MediaCenterInfoHeaderEnum : TitleEnum {
    MEDIA,
    DEVICES;

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            MEDIA -> strings.media
            DEVICES -> strings.devices
        }
    }

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                MEDIA -> strings.media
                DEVICES -> strings.devices
            }
        }
}